/**
 * PageHeader — the Cormorant title + subtitle + right-aligned actions block
 * that every page reinvents inline. Keeps the serif heading, muted subtitle,
 * and an actions slot consistent across the app.
 *
 * Props:
 *   title    — serif page title (string or node)
 *   subtitle — muted supporting line
 *   actions  — node rendered right-aligned (buttons, etc.)
 */
export default function PageHeader({ title, subtitle, actions, className = '' }) {
  return (
    <div className={`flex items-start justify-between gap-3 flex-wrap mb-6 ${className}`}>
      <div className="min-w-0">
        <div className="text-[24px] font-bold mb-[5px]" style={{ fontFamily: 'var(--font-serif)' }}>
          {title}
        </div>
        {subtitle && <div className="text-[13px] text-[#7a7060]">{subtitle}</div>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>}
    </div>
  );
}
